import React from 'react'
import TextInput from 'components/TextInput'
import Button from 'components/Button'
import {
  Gender,
  Ethnicity,
  Race,
  UserFormValues,
  UserFieldName,
  getErrorMessage,
} from '@modmd/data'
import { FormikProps } from 'formik'
import { DateInput } from 'components/DateInput'
import { formatISO, parseISO } from 'date-fns'
import { SelectInput } from 'components/SelectInput'
import { maskPhone } from 'utils/helpers'

interface FormEditProps {
  userForm: FormikProps<UserFormValues>
  isDisabled?: boolean
  isFetching?: boolean
  onSubmit?: () => void
}

export function FormEdit({
  userForm,
  isDisabled = false,
  isFetching = false,
  onSubmit = () => {},
}: FormEditProps) {
  return (
    <>
      <TextInput
        name={UserFieldName.FIRSTNAME}
        value={userForm.values.firstName || ''}
        label="Firstname"
        onChange={userForm.handleChange}
        onBlur={userForm.handleBlur}
        disabled={isDisabled}
        errorMessage={getErrorMessage(userForm.touched.firstName, userForm.errors.firstName)}
      />
      <TextInput
        name={UserFieldName.LASTNAME}
        value={userForm.values.lastName || ''}
        label="Lastname"
        onChange={userForm.handleChange}
        onBlur={userForm.handleBlur}
        disabled={isDisabled}
        errorMessage={getErrorMessage(userForm.touched.lastName, userForm.errors.lastName)}
      />
      <TextInput
        name={UserFieldName.PHONE_NUMBER}
        value={maskPhone(userForm.values.phoneNumber as string) || ''}
        label="Phone number"
        onChange={userForm.handleChange}
        onBlur={userForm.handleBlur}
        disabled={isDisabled}
        errorMessage={getErrorMessage(userForm.touched.phoneNumber, userForm.errors.phoneNumber)}
      />
      <DateInput
        id="birthdate"
        name={UserFieldName.BIRTHDATE}
        label="Birthdate"
        onBlur={userForm.handleBlur}
        value={userForm.values.birthDate ? parseISO(userForm.values.birthDate) : null}
        onChange={(date) => {
          userForm.setFieldValue('birthDate', date ? formatISO(date) : null)
        }}
        errorMessage={getErrorMessage(userForm.touched.birthDate, userForm.errors.birthDate)}
        disabled={isDisabled}
        isFullWidth
      />
      <SelectInput
        name={UserFieldName.GENDER}
        label="Gender"
        onChange={userForm.handleChange}
        value={userForm.values.gender || ''}
        hasEmptyValue
        options={[
          { value: '', label: 'Choose one', disabled: true },
          { value: Gender.Male, label: 'Male' },
          {
            value: Gender.Female,
            label: 'Female',
          },
          {
            value: Gender.Other,
            label: 'Other',
          },
          {
            value: Gender.DeclineToState,
            label: 'Decline to state',
          },
        ]}
        disabled={isDisabled}
        errorMessage={getErrorMessage(userForm.touched.gender, userForm.errors.gender)}
      />
      <SelectInput
        name={UserFieldName.ETHNICITY}
        label="Ethnicity"
        hasEmptyValue
        onChange={userForm.handleChange}
        value={userForm.values.ethnicity || ''}
        options={[
          { value: '', label: 'Choose one', disabled: true },
          { value: Ethnicity.Hispanic, label: 'Hispanic' },
          { value: Ethnicity.NotHispanic, label: 'Not-Hispanic' },
          { value: Ethnicity.DeclineToState, label: 'Decline to state' },
        ]}
        disabled={isDisabled}
        errorMessage={getErrorMessage(userForm.touched.ethnicity, userForm.errors.ethnicity)}
      />
      <SelectInput
        name={UserFieldName.RACE}
        label="Race"
        hasEmptyValue
        onChange={userForm.handleChange}
        value={userForm.values.race || ''}
        options={[
          { value: '', label: 'Choose one', disabled: true },
          { value: Race.AmericanIndian, label: 'American Indian/Alaska Native' },
          { value: Race.Asian, label: 'Asian' },
          { value: Race.Black, label: 'Black' },
          { value: Race.Hawaiian, label: 'Hawaiian/Pacific Islander' },
          { value: Race.White, label: 'White' },
          { value: Race.Other, label: 'Other' },
          { value: Race.DeclineToState, label: 'Decline to State' },
        ]}
        disabled={isDisabled}
        errorMessage={getErrorMessage(userForm.touched.race, userForm.errors.race)}
      />
      <Button isFetching={isFetching} onClick={onSubmit}>
        Save
      </Button>
    </>
  )
}
